import { DropdownMenu } from '#/components/ui/DropdownMenu';
import { Icon } from '#/components/ui/icons';

import type { FacetOption } from './facetOptions';
import { FacetMenu } from './searchFacetFilterPrimitives';
import { getMultiSelectTriggerLabel } from './searchFacetFilterUtils';

export function MultiSelectFacetMenu({
  label,
  selectedValues,
  options,
  triggerClassName,
  popupClassName,
  popupMatchTrigger,
  onToggle,
}: {
  label: string;
  selectedValues: string[];
  options: FacetOption[];
  triggerClassName?: string;
  popupClassName?: string;
  popupMatchTrigger?: boolean;
  onToggle: (value: string) => void;
}) {
  const selectableOptions = options.filter((option) => option.value);

  return (
    <FacetMenu
      triggerLabel={getMultiSelectTriggerLabel({
        label,
        selectedValues,
        options: selectableOptions,
      })}
      triggerClassName={triggerClassName}
      triggerTrackProps={{
        'data-track': 'search_facet_open',
        'data-track-label': label,
        'data-track-context': 'search_facet',
      }}
      popupClassName={popupClassName}
      popupMatchTrigger={popupMatchTrigger}
    >
      {selectableOptions.map((option) => (
        <DropdownMenu.CheckboxItem
          key={option.value}
          checked={selectedValues.includes(option.value)}
          onCheckedChange={() => onToggle(option.value)}
        >
          <DropdownMenu.CheckboxItemIndicator>
            <Icon id="check" size={16} aria-hidden="true" />
          </DropdownMenu.CheckboxItemIndicator>

          <span>{option.label}</span>
        </DropdownMenu.CheckboxItem>
      ))}
    </FacetMenu>
  );
}
